// extracted by mini-css-extract-plugin
export default {"app":"Main_app__MwuqZ","backgroundImg":"Main_backgroundImg__07qdr","versionText":"Main_versionText__XkWBD"};